export default __webpack_public_path__ + "static/media/whyStartups.png.webp";